<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d7e2929">PREFACE</p>
<p class="tx" id="d7e2979">Although nearing its one hundredth anniversary, Arizona is still one of the nation’s youngest states. Yet it is this very youth—coupled with its citizenry’s mixed backgrounds and its great variety of plant and animal life, landforms, terrain, and climates—that makes it a fascinating source of trivia. You will find in the following pages hundreds of questions and answers on all aspects of Arizona’s past and present, its people and its economy, its culture and its geography. I hope that you enjoy reading <i>Arizona Trivia,</i> the latest in Rutledge Hill Press’s continuing series of trivia titles, as much as I enjoyed compiling it.</p>
<p class="txr" id="d7e3439">James A. Crutchfield</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Crut_9781418557348_epub_c11_r1.vue?54ac6792